<irembogov-image
  [formControl]="formControl"
  [desktopWidth]="field.props['width']"
  [tabletWidth]="field.props['tabletWidth']"
  [mobileWidth]="field.props['mobileWidth']"
  [objectFit]="field.props['objectFit']"
  [borderRadius]="field.props['borderRadius']"
  [alt]="field.props['alt']">
</irembogov-image>
